import { Component, OnInit } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';
import { BookingOffer } from './../../models/bookings/bookings.model';

@Component({
  selector: 'swb-booking-offer-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html'
})
export class BookingOfferListComponent extends ListBase<BookingOffer> implements OnInit {

  public url = 'booking-offers';
  public urlPrefix = 'bookings';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }
}
